import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const OrderSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderId = location.state?.orderId;

  useEffect(() => {
    // Redirect to home if no order ID (direct visit)
    if (!orderId) {
      navigate('/');
    }
  }, [orderId, navigate]);

  return (
    <div className="bg-navy text-gray-800 min-h-screen flex items-center justify-center py-10">
      <div className="text-center max-w-lg mx-auto px-4">
        <div className="flex justify-center mb-6">
          <CheckCircle size={80} className="text-green-600" />
        </div>

        <h1 className="text-4xl font-bold mb-4 text-gray-900">Order Confirmed!</h1>

        <p className="text-lg text-gray-600 mb-6">
          Thank you for your purchase. Your order has been successfully placed and submitted.
        </p>

        {orderId && (
          <div className="bg-navy-light border border-primary/20 rounded-lg p-6 mb-8">
            <p className="text-gray-500 text-sm mb-2">Order ID</p>
            <p className="text-2xl font-bold text-primary break-all">{orderId}</p>
          </div>
        )}

        <p className="text-gray-500 mb-8">
          A confirmation email will be sent to your email address with order details and tracking information.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/')}
            className="w-full bg-primary hover:bg-primary-dark text-white font-medium py-3 rounded-md transition"
          >
            Continue Shopping
          </button>

          <button
            onClick={() => navigate('/account/orders')}
            className="w-full border border-primary/30 text-gray-600 hover:text-primary font-medium py-3 rounded-md transition"
          >
            View My Orders
          </button>
        </div>

        <p className="text-gray-500 text-sm mt-8">
          If you have any questions, please contact our support team at support@elitemedapparel.com
        </p>
      </div>
    </div>
  );
};

export default OrderSuccessPage;